import React from 'react'
import { CreatePoints } from './create-forms/CreatePoints'

export const Create = () => {
  return (
    <CreatePoints></CreatePoints>
  )
}
